<template>
  <div class="page-container">
    <el-breadcrumb >
      <el-breadcrumb-item>内部转账</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
        
      <div class="page-actions">
        <create @refresh="getList"></create>
        <el-input placeholder="请输入转入账号" clearable v-model="userId">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
      </div>
      <list @refresh="getList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapActions, mapState, mapGetters } from 'vuex';
import List from './components/list';
import Create from './components/create';

export default {
  name: 'TransferInner',
  data() {
    return {
      userId: ''
    };
  },
  components: {
    List,
    Create
  },
  computed: {
    ...mapState('transferInner', [ 'pagination']),
    ...mapGetters('transferInner', ['list'])
  },
  methods: {
    ...mapActions('transferInner', ['reqList', 'getCoinTypes']),
     handleSearch() {
      this.getList({ page: 1 });
    },
    getList(data = {}) {
      this.reqList({
        userId: this.userId,
        ...this.pagination,
        ...data
      });
    }
  },
  created() {
    this.getCoinTypes();
    this.getList();
  }
};
</script>

<style lang="less" scoped>
.actions-bar {
  display: flex;
  align-items: center;
}

.el-input {
  width: 300px;
}

.el-date-editor,
.el-input {
  margin-right: 10px;
}
</style>
